/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import {
    Avatar,
    Divider,
    ListItemButton,
    ListItemAvatar,
    ListItemText,
    ListItemSecondaryAction,
    Typography
} from "@mui/material";
import { BellOutlined } from "@ant-design/icons";

const NotificationItem = (props) => {
    const {
        // iconColour = 'success.main',
        iconColor = "#FFFFFF",
        iconBackgroundColor = "#00685E",
        // icon = <GiftOutlined />,
        icon = <BellOutlined />,
        when = "3:00 AM",
        textMain = "News content ready for review.",
        textSub = "Due: October 12, 5PM",
        // target = 'manage-tasks',
        handleItemClick
    } = props || {};
    
    const isIcon = typeof icon !== "string";
    
    return (
        <>
            <ListItemButton
                // style={{ border: '1px solid red'}}
                onClick={(e) => handleItemClick(e, "manage-tasks")}
            >
                <ListItemAvatar>
                    <Avatar sx={{ color: iconColor, bgcolor: iconBackgroundColor }} >
                        {isIcon ? (
                            <div className='notification-svg-icon'>{icon}</div>
                        ) : (
                            <>{icon}</>
                        )}
                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    title={textMain}
                    primary={
                        <Typography variant='h6' style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
                            {textMain}
                        </Typography>
                    }
                    secondary={textSub}
                />
                <ListItemSecondaryAction>
                    <Typography variant='caption' noWrap>
                        {when}
                    </Typography>
                </ListItemSecondaryAction>
            </ListItemButton>

            <Divider />
        </>
    );
};

export default NotificationItem;
